export const enum whatifProcess {
    editPaymentIn = "Edit payments in",
    editAdviserCharges = "Edit adviser charges",
    AddAdditionalAdviserCharge = "Add additional adviser charge",
    editInvestmentSeletion = "Edit investment selection",
    AddEditRegularWithdrawals = "Add/edit regular withdrawals",
    AddOneOffWithdrawal = "Add one-off withdrawal",
    ConvertCappedToFlexi = "Convert Capped to Flexible Drawdown",
    TakePensionBenefits = "Take pension benefits",
    EditIncomeDrawdown = "Edit Income Drawdown",
    EditIncomePayments = "Edit income payments",
    SIPPOneOffIncomePayment = "One-off Income Payment",
}

export const whatIfModelArray = [
    whatifProcess.editPaymentIn,
    whatifProcess.editAdviserCharges,
    whatifProcess.AddAdditionalAdviserCharge,
    whatifProcess.editInvestmentSeletion,
    whatifProcess.AddEditRegularWithdrawals,
    whatifProcess.AddOneOffWithdrawal
];

export const whatIfSippModelArray = [
    whatifProcess.editPaymentIn,
    whatifProcess.editAdviserCharges,
    whatifProcess.AddAdditionalAdviserCharge,
    whatifProcess.editInvestmentSeletion,
    // Comment out for R64 in SLP-174563, to be fixed post R64
    //whatifProcess.ConvertCappedToFlexi,
    whatifProcess.TakePensionBenefits,
    whatifProcess.EditIncomeDrawdown,
    whatifProcess.EditIncomePayments,
    whatifProcess.SIPPOneOffIncomePayment
];



export const stepTitle = {
    ClientDetails: "Client details",
    ChangesToBeModelled: "Changes to be modelled",
    EditPaymentIn: "Edit payments in",
    EditAdviserCharges: "Edit adviser charges",
    editInvestmentSeletion: "Edit investment selection",
    AddAdditionAdviserCharges: "Add additional adviser charge",
    addEditRegularWithdrawals: "Add/edit regular withdrawals",
    addOneOffWithdrawal: "Add one-off withdrawal",
    convertCappedToFlexi:"Convert Capped to Flexible Drawdown",
    takePensionBenefits:"Take Pension Benefits",
    editIncomeDrawdown:"Edit Income Drawdown",
    editIncomePayments:"Edit Income Payments",
    sIPPOneOffIncomePayment:"One Off Income Payment",
    incomePaymentDetails:"Income payment details",
    review: "Illustration ready",
    confirm: "Confirmation",
};


